define(function (require) {
	const modal_tpl = require('./t_lov_dynamic_form_modal.hbs');
	const tpl = require('./t_lov_dynamic_form.hbs');
	const detail_page_modal_view = require('civicsViews/detail_view/modal_view/v_lov_modal_detail');
	return Marionette.LayoutView.extend({
		template: tpl,
		ui: {
			saveButton: '.save-button',
			cancelButton: '.cancel-button',
			formDiv: '.form-detail-page',
			closeButton: '.bbm-btn-close'
		},
		events: {
			'click @ui.saveButton': 'saveClicked',
			'click @ui.cancelButton': 'cancelClicked',
			'click @ui.closeButton': 'closeClicked'
		},
		regions: {
			formRegion: '@ui.formDiv'
		},
		class:'dynamic-form',
		initialize: function (options) {
			if (options.elements == null || options.saveCallback == null || options.cancelCallback == null) {
				return false;
			}
			if (options.isModal) {
				this.template = modal_tpl;
			}
			this.elements = options.elements;
			this.values = options.values;
			this.saveCallback = options.saveCallback;
			this.saveCallbackData = options.saveCallbackData;
			this.cancelCallback = options.cancelCallback;
			this.cancelCallbackData = options.cancelCallbackData;
			this.cancelRequiresData = options.cancelRequiresData === true;
			this.closeCallback = options.closeCallback;
			this.closeCallbackData = options.closeCallbackData;
			this.titleText = options.titleText;
			this.saveText = options.saveText;
			this.cancelText = options.cancelText;
			this.formClass = options.formClass;
			this.skipValidation = options.skipValidation === true;
			this.noSaveButton = options.noSaveButton === true;

		},
		onShow: function () {
			this.detailView = new detail_page_modal_view({
				elements: this.elements,
				values: this.values
			});
			this.formRegion.show(this.detailView);
			this.$el.rhythmThemeInitCivics();
			$('[data-showCharacterCount="true"]').each((index,el)=>{
				$(el).maxlength();
			});

		},
		templateHelpers: function () {
			return {
				titleText: this.titleText,
				saveText: this.saveText,
				cancelText: this.cancelText,
				formClasses: (this.formClass? this.formClass+' ':'')+'modal-detail-el',
				noSaveButton: this.noSaveButton
			}
		},
		saveClicked: function (e) {
			this.ui.saveButton.prop('disabled', true);
			if (e) {
				e.preventDefault();
				e.stopPropagation();
			}
			var data = this.detailView.getData(this.skipValidation);
			if (data || this.skipValidation) {
				this.saveCallback(data, this.saveCallbackData);
			} else {
				this.ui.saveButton.prop('disabled', false);
			}
		},
		cancelClicked: function (e) {
			if (e) {
				e.preventDefault();
				e.stopPropagation();
			}
			if(this.cancelRequiresData){
				var data = this.detailView.getData();
				if (data) {
					this.cancelCallback(data, this.cancelCallbackData);
				}
			} else {
				this.cancelCallback(this.cancelCallbackData);
			}
		},
		closeClicked: function (e) {
			if (e) {
				e.preventDefault();
				e.stopPropagation();
			}
			if(this.closeCallback){
				this.closeCallback(this.closeCallbackData);
			} else {
				this.cancelClicked(e);
			}
		}
	});
});